import smPanel from './src/smPanel';

export default smPanel;


// WEBPACK FOOTER //
// ./src/components/smPanel/index.js